<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-5 px-4 pt-4 text-center">
            <div class="btn-group card-tr-actions" dropdown placement="bottom right">
                <button class="btn btn-link btn-link-dark p-0 text-dark opacity-8 dropdown-toggle no-caret"
                        dropdownToggle
                        type="button">
                    <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                </button>
                <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
                    <ul class="nav nav-pills flex-column p-3">
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>My Account</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link active">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                        <li class="nav-item nav-item--header text-first font-weight-bold">
                            <span>Heading</span>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-header-alt">
                <div class="font-weight-bold font-size-lg mb-0 text-black">
                    Financial year
                </div>
                <p class="text-black-50">Expenses statistics to date</p>
            </div>
            <div class="divider my-4"></div>
            <h3 class="mb-0 display-3 mt-1 font-weight-bold">
                $
                <span [countUp]="458695"></span>
            </h3>
            <div class="divider my-4"></div>
            <div class="row">
                <div class="col-md-6">
                    <span class="opacity-6 pb-2">Current month</span>
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="font-weight-bold font-size-lg">
                            <small class="opacity-6">$</small>
                            46,362
                        </span>
                        <span class="badge bg-neutral-danger ml-2 text-danger">-8%</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <span class="opacity-6 pb-2">Last year</span>
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="font-weight-bold font-size-lg">
                            <small class="opacity-6">$</small>
                            34,546
                        </span>
                        <span class="badge bg-neutral-success ml-2 text-success">+13%</span>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold font-size-lg mt-4 text-black">
                Monthly report
            </div>
            <apx-chart
                    [chart]="{
                                type: 'bar',
                                height: '365',
                                sparkline: {
                                  enabled: false
                                },
                                toolbar: {
                                    show: false
                                }
                            }"
                    [colors]="['#f4772e', '#4191ff']"
                    [dataLabels]="{
                              enabled: false
                            }"
                    [fill]="{
                              opacity: 0.85,
                              colors: ['#f4772e', '#4191ff']
                            }"
                    [grid]="{
                            strokeDashArray: '5',
                            borderColor: 'rgba(125, 138, 156, 0.3)'
                        }"
                    [labels]="['January', 'February', 'March', 'April', 'May', 'June', 'July']"
                    [legend]="{ show: false }"
                    [series]="[
                              {
                                name: 'Net Profit',
                                data: [3.3, 3.1, 4.0, 5.8, 2.1, 3.6, 3.2]
                              },
                              {
                                name: 'Net Loss',
                                data: [2.1, 2.1, 2.8, 2.8, 4.3, 2.7, 1.4]
                              }
                            ]"

                    [stroke]="{
                              show: true,
                              width: 2,
                              colors: ['transparent']
                            }"
            ></apx-chart>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5 p-4 bg-gray-100 text-center">
            <apx-chart
                    [chart]="{
                    type: 'line',
                    height: '320',
                    shadow: {
                      enabled: false,
                      color: '#bbb',
                      top: 3,
                      left: 2,
                      blur: 3,
                      opacity: 1
                  }
                            }"
                    [fill]="{
                  type: 'gradient',
                  gradient: {
                      shade: 'dark',
                      gradientToColors: [ '#FFA41B'],
                      shadeIntensity: 1,
                      type: 'horizontal',
                      opacityFrom: 1,
                      opacityTo: 1,
                      stops: [0, 100, 100, 100]
                  }
        }"
                    [grid]="{
                    borderColor: 'rgba(125, 138, 156, 0.4)'
                }"

                    [markers]="{
            size: 6,
            opacity: 0.9,
            colors: ['#FFA41B'],
            strokeColor: '#fff',
            strokeWidth: 2,

            hover: {
              size: 10
            }
        }"

                    [series]="[
                    {
                      name: 'Likes',
                      data: [4, 3, 10, 9, 29, 19, 22, 9, 12, 7, 19, 5, 13, 9, 17, 2, 7, 5]
                    }
                  ]"
                    [stroke]="{
                    width: 7,
                    curve: 'smooth'
                  }"

                    [xaxis]="{
                type: 'datetime',
                categories: ['1/11/2000', '2/11/2000', '3/11/2000', '4/11/2000', '5/11/2000', '6/11/2000', '7/11/2000', '8/11/2000', '9/11/2000', '10/11/2000', '11/11/2000', '12/11/2000', '1/11/2001', '2/11/2001', '3/11/2001','4/11/2001' ,'5/11/2001' ,'6/11/2001']
        }"
            ></apx-chart>

            <div class="row">
                <div class="col-lg-6">
                    <ngx-gauge backgroundColor="#e5e6ef" cap="round" class="img-fluid" foregroundColor="#11c5db"
                               label="Expenses" max="120" min="0"
                               size="180" thick="8"
                               type="arch" value="32.51">
                    </ngx-gauge>
                </div>
                <div class="col-lg-6">
                    <ngx-gauge backgroundColor="#e5e6ef" cap="round" class="img-fluid" foregroundColor="#f83245"
                               label="Income" max="120" min="0"
                               size="180" thick="8"
                               type="arch" value="54.23">
                    </ngx-gauge>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="card shadow-none rounded-lg p-4 text-left bg-white">
                        <div class="btn-group card-tr-actions" dropdown placement="bottom right">
                            <button class="btn btn-link btn-link-dark p-0 text-dark opacity-8 dropdown-toggle no-caret"
                                    dropdownToggle
                                    type="button">
                                <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                            </button>
                            <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
                                <ul class="nav nav-pills flex-column p-3">
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>My Account</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link active">
                                            <span>Profile settings</span>
                                            <div class="ml-auto badge badge-first">23</div>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>Active tasks</span>
                                        </a>
                                    </li>
                                    <li class="nav-item nav-item--header text-first font-weight-bold">
                                        <span>Heading</span>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>Profile settings</span>
                                            <div class="ml-auto badge badge-first">23</div>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>Active tasks</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-4">
                            <div class="avatar-icon-wrapper mr-2">
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                            </div>
                            <div>
                                <div class="font-weight-bold text-dark text-uppercase font-size-sm opacity-7 pb-1">Top customer</div>
                                <span class="text-black font-size-lg d-block">Demi-Lee Bouvet</span>
                            </div>
                        </div>
                        <div class="align-bottom">
                            <span class="font-size-xl font-weight-bold">1748</span>
                            <span class="text-dark font-weight-bold font-size-sm opacity-7"> / purchases</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="card shadow-none rounded-lg p-4 text-left bg-white">
                        <div class="btn-group card-tr-actions" dropdown placement="bottom right">
                            <button class="btn btn-link btn-link-dark p-0 text-dark opacity-8 dropdown-toggle no-caret"
                                    dropdownToggle
                                    type="button">
                                <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                            </button>
                            <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
                                <ul class="nav nav-pills flex-column p-3">
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>My Account</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link active">
                                            <span>Profile settings</span>
                                            <div class="ml-auto badge badge-first">23</div>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>Active tasks</span>
                                        </a>
                                    </li>
                                    <li class="nav-item nav-item--header text-first font-weight-bold">
                                        <span>Heading</span>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>Profile settings</span>
                                            <div class="ml-auto badge badge-first">23</div>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="" class="nav-link">
                                            <span>Active tasks</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mb-4">
                            <div class="avatar-icon-wrapper mr-2">
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                            </div>
                            <div>
                                <div class="font-weight-bold text-dark text-uppercase font-size-sm opacity-7 pb-1">Top client</div>
                                <span class="text-black font-size-lg d-block">Brayden Ball</span>
                            </div>
                        </div>
                        <div class="align-bottom">
                            <span class="font-size-xl font-weight-bold">456</span>
                            <span class="text-dark font-weight-bold font-size-sm opacity-7"> / visits</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
